/* tslint:disable */
export var icon = "\n<svg width=\"41\" height=\"12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M39.5 6H3m0 0l4 4M3 6l4-4\" stroke=\"#20455E\" stroke-width=\"3\" stroke-linecap=\"round\"/></svg>\n";
//# sourceMappingURL=pp-back-arrow.svg.js.map